// import Stomp from 'stompjs';
import SockJS from 'sockjs-client';
import { StateInterface } from 'Interfaces/StateInterface';
import { Client } from '@stomp/stompjs';
import { MODULES } from 'Interfaces/ModuleSelectionInterface';
import { setUpdatedTasks } from 'reducers/updatedTasks';
import { getFormUtils } from 'views/SingleInstance/utils/FormUtilsHolder';
import { DataPoint } from 'Interfaces/DataPoint';
import { questionTypes } from 'Interfaces/Forms/QuestionInterface';
import { getLocalization, globalWindow } from '../global/global';
import { addFeed, updateFeed, userUpdate } from './feed';
import { getFeedItem } from './utils/websocket';
import { showAlert } from './index';
import { setSingleInstanceMessage, updateOpenedDataPointAction } from './moduleSelectionActions';
import { updateClientPersist } from './clientPersistActions';



export const initWS = () => {
  return (dispatch, getState: () => StateInterface) => {
    // const socket = new SockJS('/json/ws');
    const client = new Client({
      brokerURL: `${globalWindow.location.origin.replace('http', 'ws')}/json/ws`,
      debug: function (str) {
        console.log(str);
      },
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
    });

    client.webSocketFactory = () => {
      // Note that the URL is different from the WebSocket URL
      return new SockJS('/json/ws');
    };
    client.onConnect = () => {
      client.subscribe('/user/queue/automaticupdate', (message) => {
        const response = JSON.parse(message.body);
        const users = getState().users;
        const forms = getState().forms.collection;
        const userId = getState().clientPersist.user_id;
        const selectedForms = getState().filtersMenu.selectedForms.map((sf) => sf.ref);
        const module = getState().moduleSelection.selected;

        const setSingleInstance = () => {
          const { singleInstance } = getState().moduleSelection;
          if (singleInstance && singleInstance.dataPoint.id === response.id) {
            dispatch(updateOpenedDataPointAction(response));
          }
        };

        const getTasks = () => {
          const form = forms.find(f => f.ref === response.questionnaire_id);
          if (form) {
            if (form.type === 'TASKFORM') {
              dispatch(setUpdatedTasks([response]));
            } else {
              const formUtils = getFormUtils(form);
              const taskQuestions = formUtils.getSubFormQuestionIds();
              let tasks: DataPoint[] = [];
              for (const id of taskQuestions) {
                const qn = formUtils.getQuestion(id);
                if (qn.type === questionTypes.TASK_QUESTION && response[id]) {
                  tasks = tasks.concat(response[id]);
                }
              }
              dispatch(setUpdatedTasks(tasks));
            }
          }
        };

        if (response.type) {
          if (response.type === 'NOTIFICATION') {
            dispatch(showAlert({ visible: true, message: response.message }));
          } else if (response.type === 'EDIT_NOTIFICATION') {
            const users = response.user;
            const userNameList = users
              ? users.map((u) => {
                if (u.indexOf('@') > -1) {
                  return u.substring(0, u.indexOf('@'));
                }
                return u;
              })
              : [];
            dispatch(
              setSingleInstanceMessage({
                editMessage:
                                    userNameList.length > 0
                                      ? `${userNameList.length} users (${userNameList.join(
                                        ',',
                                      )}) have opened the datapoint`
                                      : '',
              }),
            );
          } else if (response.type === 'SAME_EDIT_NOTIFICATION') {
            dispatch(setSingleInstanceMessage({ sameUserMessage: getLocalization('sameUserOpen') }));
          } else if (response.type === 'USER_CHANGES') {
            const { userData } = response;
            console.log(userData);
            const { clientPersist } = getState();
            if (clientPersist.groupId !== userData.groupId || !userData.active) {
              dispatch(updateClientPersist({ logout: true }));
            } else {
              dispatch(updateClientPersist({...userData}));
            }
          } else if (response.type === 'GMAIL_CONNECTION') {
            dispatch(updateClientPersist({ gmailConnection: response.connected === true }));
          }
        } else {
          let shouldUpdateFeed = true;
          if (selectedForms.length > 0 && selectedForms.indexOf(response.questionnaire_id) === -1) {
            shouldUpdateFeed = false;
          }
          const feedItem = getFeedItem(response, users, forms);
          if (response.user_id === Number(userId)) {
            if (shouldUpdateFeed) {
              dispatch(userUpdate([feedItem]));
            }
            /* if (response.action === 'add') {
              dispatch(feedLoaded([feedItem]));
            } else if (response.action === 'edit') {
              dispatch(updateFeed(feedItem));
            }*/
            if (module === MODULES.TASKS) {
              getTasks();
            }
            setSingleInstance();
          } else {
            if (module === MODULES.TASKS) {
              return getTasks();
            }
            if (shouldUpdateFeed) {
              if (response.action === 'add') {
                dispatch(addFeed({...feedItem, action: 'add'}));
              } else if (response.action === 'edit') {
                dispatch(updateFeed(feedItem));
                dispatch(addFeed({...feedItem, action: 'edit'}));
              }
            }
            setSingleInstance();
          }
        }
      });
    };
    client.activate();
  };
};
